import React from "react";
import "../../assets/css/profile.css"
import $ from "jquery"
import { fetchUserDetails,fetchVideoList } from "../../api/user"


class ProfileComponent extends React.Component {

  constructor(props) {

        super(props)
        this.state = {
            type : '',
            promocodes1 : null,
            promocodes2 : null,
            promocodes3 : null,
            videosList : null

        }
    }

    componentWillUnmount(){

      document.removeEventListener('mouseup', this.profilewrapper);

    }

    componentDidMount() {

      let user_id = sessionStorage.getItem("user_id");
      if(user_id) {
          let user = fetchUserDetails(user_id);
          let that = this
          user.then(function (val)  {

              if(val.data.user) {
                

                that.setState({
                  promocodes1 : val.data.user.details.uto_promo_code1,
                  promocodes2 : val.data.user.details.uto_promo_code2,
                  promocodes3 : val.data.user.details.uto_promo_code3,
    
                })

              }


                  
          })

      }


      document.addEventListener('mouseup', this.profilewrapper);
    }


    profilewrapper = (e) => {

      var container = document.getElementById('profile_wrapper');
      if (!container.contains(e.target)) {
        $("#profile_wrapper").addClass('d-none');  
      }
    }
    showEditAccount = () => {

      this.props.setModalPopupContent("profile_edit")

     $("#profile_wrapper").addClass("d-none")
      // $("#editAccountForm").modal("show");
      // $(".navigation-container").hide();
      // $(".nav-header-div").hide();
    }

    redirectVideo = (resource_id) => {

      // alert(resource_id)

      // this.props.setModalPopupContent(resource_id)

    }
    render() {

        return(
            <div className="edit_account_popup d-none" id="profile_wrapper">
            <div className="edit_account float-right">
                <a href="#" className="edit_account_inner" onClick={this.showEditAccount}>Edit Account</a>
                <a href="#" className="edit_close" onClick={() => {  
                  $("#profile_wrapper").addClass('d-none');  
                 // $(".navigation-container").show();
                  $(".nav-header-div").show();  
                }}><img src="images/edit_arrow.svg" alt="" /></a>
            </div>
            <div className="promo_code_pop mt-5">
                <h3>Promo Codes</h3>
                <div className="promo_code_pop_inner custom_scroll">
                    <ul>
                        {this.state.promocodes1 ? <li>{this.state.promocodes1}</li> : <li>NO PROMO CODE 1</li>}
                        {this.state.promocodes2 ? <li>{this.state.promocodes2}</li> : <li>NO PROMO CODE 2</li>}
                        {this.state.promocodes3 ? <li>{this.state.promocodes3}</li> : <li>NO PROMO CODE 3</li>}
                    </ul>
                </div>
            </div>
            <div className="promo_code_pop_inner promo_code_pop_inner2 mt-4 custom_scroll">
                <h4>2022 Videos:</h4>
                <table className="table">
                    <tbody>
                      {
                        this.props.profileVideos && this.props.profileVideos.map((val) => {
                          return(
                            <tr>
                              {
                                (val.video_status === "No") ? (<td><img src="images/option_icon.svg" alt="" /></td>) : (
                                  <td><img src="images/option_icon_active.svg" alt="" /></td>
                                )
                              }
                              <td>{val.title}</td>
                              {/* <td><a href="#" dat-v={val.key} onClick={() => this.redirectVideo(val.resource_id)}>{val.title}</a></td> */}
                            </tr>
                          )

                        })
                      }
                   
                    
                    </tbody>
                  </table>
                
            </div>
        </div>

        )
    }
}

export default ProfileComponent;